<template>
  <div>
    <!-- 장비유형 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 장비유형</h5>
      <div class="grid xl:grid-cols-6 gap-x-6 gap-y-4 mt-4">
        <div v-for="item in form.유형" :key="`checkbox_${item}`" class="col-span-1 flex items-center">
          <div v-if="isPrint || readonly" class="flex items-center">
            <PrintCheckbox :value="form.선택.includes(item)"/>
            <span class="ml-2">
              {{ item }}
            </span>
          </div>
          <div v-else>
          <span class="flex ">
            <vs-checkbox style="white-space: nowrap;" :readonly="readonly" :value="form.선택.includes(item)" @change="handleChange(item)">{{ item }}</vs-checkbox>
            <ml-input v-if="item === '기타'" v-model="form.기타.note" :disabled="!form.선택.includes('기타')"/>
          </span>
          </div>
        </div>
      </div>
    </div>

    <!-- 지게차 -->
    <component v-for="item in form.선택" :key="item" :is="getComponent(item)" v-model="form[item]" :readonly="readonly" :isPrint="isPrint" :statusNumber="statusNumber"/>
  </div>
</template>

<script>
import TableInspectMerge from "@/components/TableInspectMerge.vue";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import FormForkLift from "@/views/boards/single-page/979/WorkTable979/FormForkLift.vue";
import FormMobileCrane from "@/views/boards/single-page/979/WorkTable979/FormMobileCrane.vue";
import FormAerialWorkVehicle from "@/views/boards/single-page/979/WorkTable979/FormAerialWorkVehicle.vue";
import FormElevatedWorkPlatform from "@/views/boards/single-page/979/WorkTable979/FormElevatedWorkPlatform.vue";
import FormExcavatorWorkPlatform from "@/views/boards/single-page/979/WorkTable979/FormExcavatorWorkPlatform.vue";
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";

export default {
  name: "WorkTable979",
  components: {PrintCheckbox, TableCustom, TimeSelector, TableInspectMerge},
  props: {
    readonly: Boolean,
    isPrint: Boolean,
    board: Object,
    value: Object,
    statusNumber: Number,
  },
  computed: {
    form: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    handleChange(value) {
      if (this.form.선택.includes(value)) {
        this.form.선택 = this.form.선택.filter(item => item !== value);
      } else {
        this.form.선택.push(value);
      }
    },
    getComponent(name) {
      if (name === "지게차") return FormForkLift;
      if (name === "이동식크레인") return FormMobileCrane;
      if (name === "고소작업차") return FormAerialWorkVehicle;
      if (name === "고소작업대") return FormElevatedWorkPlatform;
      if (name === "굴삭기") return FormExcavatorWorkPlatform;
      return false;
    },
  },
}
</script>

<style scoped>

</style>
